import { BackClick, HeaderStyled, TextBox } from '@/components/Header/styled';
import Image from 'next/legacy/image';
import { BackArrow, Exit, HeaderLogo } from '@/icons';
import { getSessionStorage, imageLoader } from '@/utils';
import { Fragment, useEffect, useState } from 'react';
import StepProgressBar from '@/components/StepProgressBar';
import router, { useRouter } from 'next/router';
import useSessionStorage from '@/hooks/useSessionStorage';
import { isWebViewClient } from '@/utils/omniture';
import vfWebView from '@vodafonetr/vf-webview-ts';
import Link from 'next/link';
const Header = ({ success = false }: { success?: boolean }) => {
  const route = useRouter();
  const [channel, setChannel] = useState<any>();
  const [isArrowVisible, setIsArrowVisible] = useState<boolean>();
  const [isBackDisabled, setIsBackDisabled] = useState<boolean>(false);
  const progressSteps = [
    { id: 1, name: 'İletişim Bilgisi', path: '' },
    { id: 2, name: 'Altyapı Sorgusu', path: '/home/address' },
    { id: 3, name: 'Tarife Seçimi', path: '/home/tarife' },
    { id: 4, name: 'Kişisel Bilgiler', path: '/home/customer-info' },
  ];
  const pathName = route.route;
  const currentStep = progressSteps.find(
    (step) =>
      step?.path === pathName ||
      step?.path === `/${pathName?.split('/')?.pop()}`
  );
  const { id } = currentStep || { id: 0, name: '' };
  const nextStep = progressSteps.find((step) => step.id === id + 1);
  const previousStep = progressSteps.filter((step) => step.id === id - 1);
  const [storedData, setStoredData] = useSessionStorage('userData', {} as any);

  useEffect(() => {
    if (!['/home', '/home/address', '/home/onay'].includes(route.pathname)) {
      if (window?.clientVariables?.platformName != 'Android') {
        setIsArrowVisible(true);
      }
    }
  }, [route.pathname]);

  useEffect(() => {
    const channelValue =
      (route &&
        route.query &&
        route.query.channel &&
        route.query.channel.includes('app')) ||
      !!getSessionStorage('channel');
    setChannel(channelValue);
  }, [channel, route]);

  const handleBackClick = () => {
    if (!isBackDisabled) {
      previousStep[0].path != '/home' && route.back();
      setIsBackDisabled(true);
    }
  };

  const handleClick = () => {
    if (isWebViewClient()) {
      vfWebView.openVfDeeplink('vfss://app/HOMEPAGE');
    }
  };

  return (
    <Fragment>
      {router.query.channel?.includes('app') && (
        <BackClick
          onClick={() => vfWebView.onBack()}
          style={{ padding: '10px ' }}
        >
          <Image
            src={Exit}
            alt="Vodafone Ev İnterneti"
            loader={imageLoader}
            width={24}
            height={24}
          />
        </BackClick>
      )}

      <HeaderStyled success={success}>
        <Link
          href={
            isWebViewClient()
              ? ''
              : 'https://www.vodafone.com.tr/evde-internet-fiber-basvuru/'
          }
          style={{
            textDecoration: 'none',
            display: 'flex',
            flex: '2',
            cursor: 'pointer',
          }}
        >
          <div
            style={{ display: 'flex', flex: '2', cursor: 'pointer' }}
            onClick={() => handleClick()}
          >
            <div className="image-box">
              <Image
                src={HeaderLogo}
                alt="Vodafone Ev İnterneti"
                layout="fill"
                loader={imageLoader}
              />
            </div>
            <TextBox>
              <h1>Vodafone Ev İnterneti</h1>
            </TextBox>{' '}
          </div>
        </Link>

        {!!channel && isArrowVisible && (
          <BackClick onClick={handleBackClick}>
            <Image
              src={BackArrow}
              alt="Vodafone Ev İnterneti"
              loader={imageLoader}
              width={24}
              height={24}
            />
          </BackClick>
        )}
      </HeaderStyled>
      {pathName !== '/home/onay' && (
        <StepProgressBar active={id || 1} data={progressSteps} />
      )}
    </Fragment>
  );
};
export default Header;
